module.exports = __webpack_public_path__ + "img/imageGalery3.36886dbc.jpg";